module.exports = __webpack_public_path__ + "img/6.88a5d76.svg";